import Axios from "axios";

const url = '/report';

const reportingApi = {
    getAllReports: {
        get: () => {
            return Axios.get(`${url}`);
        }
    },
    createReport: {
        post: (params) => {
            return Axios.post(`${url}`, params);
        }
    },
    updateReport: {
        patch: (id, body) => {
            return Axios.patch(`${url}/${id}`, body);
        }
    },
    deleteReport: {
        delete: (id) => {
            return Axios.delete(`${url}/${id}`);
        }
    },
    getReportContentPage: {
        post: (params) => {
            return Axios.post(`${url}/content`, params);
        }
    },
    getReportFilters: {
        post: (params) => {
            return Axios.post(`${url}/filters`, params);
        }
    },
    getChildLocations: {
        post: (params) => {
            return Axios.post(`${url}/filters/children`, params);
        }
    },
    createSystemReport: {
        post: (params) => {
            return Axios.post(`${url}/system-report`, params);
        }
    },
    shareReport: {
        post: (params) => {
            return Axios.post(`${url}/share`, params);
        }
    },
    exportReport: {
        post: (params) => {
            return Axios.post(`${url}/export`, params);
        }
    }
};

export default reportingApi;